import { get } from '../../utils/axios'

export const listReportGustoAmountAPI = async (body) => {
  return await get('report/gusto/amount', body)
}
export const excelReportGustoAmountAPI = async (body) => {
  return await get('excel/gusto/amount', body)
}
